<template>
  <el-table :data="regions" class="table-responsive table-striped table-hover" highlight-current-row @current-change="onHighlightRegion" header-row-class-name="thead-light"
    style="width: 100%;">
    <el-table-column width="30px" v-slot="{ row }">
      <el-tooltip v-if="!(row.region_position && row.region_position.lat)" content="Necessário adicionar a localização." placement="top">
        <i class="fas fa-map-marker-alt text-danger ml-2"></i>
      </el-tooltip>
    </el-table-column>
    <el-table-column label="Nome" prop="name" sortable />

    <el-table-column label="Ações" width="80px" prop="acoes" v-slot="{ row }"
      v-if="$can('update', 'region') || $can('destroy', 'region')">
      <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer;">
        <span class="btn btn-sm btn-icon-only text-success ml-3">
          <i class="fas fa-ellipsis-v mt-2"></i>
        </span>
        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
          <a class="dropdown-item" @click="onHighlightRegion(row)">Mostrar no mapa</a>
          <a class="dropdown-item" v-if="$can('destroy', 'region')" @click="onEdit(row)">Editar</a>
          <!-- <a class="dropdown-item" v-if="$can('destroy', 'region')" @click="onRemove(row)">Excluir</a> -->
        </el-dropdown-menu>
      </el-dropdown>
    </el-table-column>
  </el-table>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  Dropdown,
} from "element-ui";

import swal from "sweetalert2";

export default {
  name: "region-list",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    regions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onHighlightRegion(region) {
      this.$emit('highlight-region', region);
    },
    onEdit(region) {
      this.$emit('edit-region', region);
    },
    onRemove(region) {
      swal.fire({
        title: 'Deseja realmente excluir?',
        text: 'Esta ação não poderá ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit('remove-region', region);
        }
      });
    },
  },
};
</script>
